"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../abstracts/helpers");
var ganttlab_entities_1 = require("ganttlab-entities");
function getTaskFromGitLabIssue(gitlabIssue) {
    var _a = helpers_1.issueDescriptionToTaskDetails(gitlabIssue.description), startDate = _a.startDate, dueDate = _a.dueDate;
    return new ganttlab_entities_1.Task(gitlabIssue.title, gitlabIssue.web_url, startDate
        ? startDate
        : gitlabIssue.milestone && gitlabIssue.milestone.start_date
            ? new Date(gitlabIssue.milestone.start_date)
            : new Date(gitlabIssue.created_at), dueDate
        ? dueDate
        : gitlabIssue.due_date
            ? new Date(gitlabIssue.due_date)
            : gitlabIssue.milestone && gitlabIssue.milestone.due_date
                ? new Date(gitlabIssue.milestone.due_date)
                : undefined);
}
exports.getTaskFromGitLabIssue = getTaskFromGitLabIssue;
function getPaginationFromGitLabHeaders(headers) {
    return {
        previousPage: headers['x-prev-page']
            ? parseInt(headers['x-prev-page'])
            : undefined,
        nextPage: headers['x-next-page']
            ? parseInt(headers['x-next-page'])
            : undefined,
        lastPage: headers['x-total-pages']
            ? parseInt(headers['x-total-pages'])
            : undefined,
        total: headers['x-total'] ? parseInt(headers['x-total']) : undefined,
    };
}
exports.getPaginationFromGitLabHeaders = getPaginationFromGitLabHeaders;
function getMilestoneFromGitLabMilestone(gitlabMilestone) {
    return new ganttlab_entities_1.Milestone(gitlabMilestone.title, undefined, gitlabMilestone.description, gitlabMilestone.start_date
        ? new Date(gitlabMilestone.start_date)
        : undefined, gitlabMilestone.due_date ? new Date(gitlabMilestone.due_date) : undefined);
}
exports.getMilestoneFromGitLabMilestone = getMilestoneFromGitLabMilestone;
//# sourceMappingURL=helpers.js.map